export default "__VITE_ASSET__C$ccR4aa__"